<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <LeituraPromocao />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import LeituraPromocao from "../Components/Leituras/LeituraPromocao.vue";
export default {
  name: "ReadPromo",
  components: {
    LeituraPromocao,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>